import axios from "axios";
import React, { useState,useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import { handle401 } from "../../../utils/handleAuthError";
import Swal from "sweetalert2";

const BASE_URL = "https://sutmmgdev.codydeasoftech.in/api";

const IssueFabric = () => {
  const [loading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [receiveList, setReceiveList] = useState([]);
  const [listLoading, setListLoading] = useState(false);

const [page, setPage] = useState(1);
const [isEditMode, setIsEditMode] = useState(false);
const [editId, setEditId] = useState(null);
const [editRow, setEditRow] = useState(null);

const [vendorList, setVendorList] = useState([]);
const [filters, setFilters] = useState({
  vendor_type_id: "",
  vendor_id: "",
});
const [vendorTypeList, setVendorTypeList] = useState([]);
const [modalTableData, setModalTableData] = useState([]);
const [modalLoading, setModalLoading] = useState(false);
const [receiveQtyMap, setReceiveQtyMap] = useState({});
const [selectedRows, setSelectedRows] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
const [selectedVendorType, setSelectedVendorType] = useState("");
  const today = new Date().toISOString().split("T")[0]; // "YY

  const [formData, setFormData] = useState({
    fabric_type: "",
    quantity: "",
    issue_date: today,
    issue_to: "",
    vendor: "",
  });


  const resetModalState = () => {
  setFormData({
    fabric_type: "",
    quantity: "",
    issue_date: "",
    issue_to: "",
    vendor: "",
    remarks: "",
    beneficiary_id: "",
  });

  setModalTableData([]);
  setSelectedRows([]);
  setReceiveQtyMap({});
  setIsEditMode(false);
  setEditRow(null);
  setEditId(null);
};



const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};



  const handleReceiveQtyChange = (row, value) => {
  const qty = Number(value) || 0;

  if (qty > row.total_quantity) return; // safety

  setReceiveQtyMap((prev) => ({
    ...prev,
    [row.id]: qty,
  }));
};




  const fetchVendorTypes = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorTypesList`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      setVendorTypeList(res.data.data || []);
    } else {
      setVendorTypeList([]);
    }
  } catch (error) {
    console.error("Vendor type fetch failed", error);
        if (handle401(error)) return;

    setVendorTypeList([]);
  }
};

const fetchVendorsByType = async (vendorTypeId) => {
  if (!vendorTypeId) {
    setVendorList([]);
    return;
  }

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      { vendor_type_id: vendorTypeId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      setVendorList(res.data.data || []);
    } else {
      setVendorList([]);
    }
  } catch (error) {
    console.error("Vendor fetch failed", error);
        if (handle401(error)) return;

    setVendorList([]);
  }
};


// const fetchReceiveCutpieceList = async (page= 1) => {
//   try {
//     setListLoading(true);
//     const token = localStorage.getItem("token");

//     const payload = {
//       page: page,
//       per_page: perPage,
//     };

//     // // optional filters
//     // if (filterVendorType) payload.vendor_type_id = filterVendorType;
//     // if (filterVendor) payload.vendor_id = filterVendor;

//     const res = await axios.post(
//       `${BASE_URL}/receiveCutpieceList`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data?.status === true) {
//       setReceiveList(res.data.data || []);
//     } else {
//       setReceiveList([]);
//     }
//   } catch (error) {
//     console.error("Receive cutpiece list fetch failed", error);
//     if (handle401(error)) return;
//     setReceiveList([]);
//   } finally {
//     setListLoading(false);
//   }
// };


const fetchReceiveCutpieceList = async (
  page = 1,
  filterOverride = {},
  perPageOverride = perPage
) => {
  try {
    setListLoading(true);
    const token = localStorage.getItem("token");

    const payload = {
      page,
      per_page: perPageOverride,
      vendor_type_id: filterOverride.vendor_type_id || undefined,
      vendor_id: filterOverride.vendor_id || undefined,
      searchKey: filterOverride.searchText || undefined,
    };

    const res = await axios.post(`${BASE_URL}/receiveCutpieceList`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data?.status === true) {
      setReceiveList(res.data.data || []);
      setTotalRecords(res.data.total_records || 0);
      setTotalPages(Math.ceil((res.data.total_records || 0) / perPageOverride));
      setPage(page);
    } else {
      setReceiveList([]);
      setTotalRecords(0);
      setTotalPages(1);
    }
  } catch (error) {
    console.error("Receive cutpiece list fetch failed", error);
    if (handle401(error)) return;
    setReceiveList([]);
  } finally {
    setListLoading(false);
  }
};



        // useEffect(() => { fetchReceiveCutpieceList(1); }, [perPage]);


const fetchReceiveCutpieceForModal = async (vendorTypeId, vendorId) => {
  if (!vendorTypeId || !vendorId) return;

  try {
    setModalLoading(true);
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/getDataForReceiveCutpiece`,
      {
        vendor_type_id: vendorTypeId,
        vendor_id: vendorId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data?.status === true) {
      setModalTableData(res.data.data || []);
    } else {
      setModalTableData([]);
    }
  } catch (error) {
    console.error("Modal cutpiece fetch failed", error);
    if (handle401(error)) return;
    setModalTableData([]);
  } finally {
    setModalLoading(false);
  }
};

const isRowSelected = (id) => {
  return selectedRows.some((r) => r.id === id);
};

const openEditModal = (row) => {
  setEditRow(row); // 🔹 Set first
  setEditId(row.id);
  setIsEditMode(true);

  // Set form data
  setFormData({
    issue_date: row.receive_date,
    issue_to: row.vendor_type_id,
    vendor: row.vendor,
    remarks: row.remarks || "",
  });

  // Load vendors for selected type
  fetchVendorsByType(row.vendor_type_id);

  // Set modal table
  setModalTableData([
    {
      id: row.job_works_jobs_details_id,
      issue_date: row.issue_date,
      item_name: row.item_name,
      size: row.size,
      fabric_master_name: row.fabric_requirement,
      total_quantity: row.total_quantity,
      receive_quantity: row.receive_quantity,
      pending_quantity: row.pending_quantity,
      date_of_start_returning: row.date_of_start_returning,
    },
  ]);

  // Preselect checkbox and qty
  setSelectedRows([
    {
      id: row.job_works_jobs_details_id,
      total_quantity: row.total_quantity,
    },
  ]);

  setReceiveQtyMap({
    [row.job_works_jobs_details_id]: row.receive_quantity,
  });

  setShowModal(true);
};





const toggleRowSelection = (row) => {
  setSelectedRows((prev) => {
    const exists = prev.find((r) => r.id === row.id);
    if (exists) {
      return prev.filter((r) => r.id !== row.id);
    } else {
      return [...prev, row];
    }
  });
};

const getActiveFilters = () => ({
  vendor_type_id: selectedVendorType || "",
  vendor_id: formData.vendor_id || "",
});

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD/MM/YYYY
};


// const handleSubmitReceiveCutpiece = async () => {
//   // ✅ ADD MODE VALIDATION
//   if (!isEditMode && selectedRows.length === 0) {
//     Swal.fire("Warning", "Please select at least one row", "warning");
//     return;
//   }

//   let jobIds = [];
//   let receiveQtyArr = [];
//   let pendingQtyArr = [];

//   if (isEditMode) {
//     // =========================
//     // ✅ EDIT MODE
//     // =========================
//     if (!editRow) {
//       Swal.fire("Error", "No row selected for edit", "error");
//       console.error("editRow is null!");
//       return;
//     }

//     const jobId = editRow.job_works_jobs_details_id || editRow.id; // use correct ID
//     const receiveQty = receiveQtyMap[jobId] || 0;

//     if (receiveQty <= 0) {
//       Swal.fire("Warning", "Receive quantity must be greater than 0", "warning");
//       return;
//     }

//     jobIds = [jobId];
//     receiveQtyArr = [receiveQty];
//     pendingQtyArr = [(editRow.total_quantity || 0) - receiveQty];
//   } else {
//     // =========================
//     // ✅ ADD MODE
//     // =========================
//     for (const row of selectedRows) {
//       const receiveQty = receiveQtyMap[row.id] || 0;

//       if (receiveQty <= 0) {
//         Swal.fire("Warning", "Receive quantity must be greater than 0", "warning");
//         return;
//       }

//       jobIds.push(row.id);
//       receiveQtyArr.push(receiveQty);
//       pendingQtyArr.push(row.total_quantity - receiveQty);
//     }
//   }

//   const payload = {
//     receive_date: formData.issue_date,
//     vendor_type_id: formData.issue_to,
//     vendor_id: formData.vendor,
//     job_works_jobs_details_id: jobIds,
//     receive_quantity: receiveQtyArr,
//     pending_quantity: pendingQtyArr,
//     remarks: formData.remarks || "",
//   };

//   // ✅ IMPORTANT FOR EDIT
//   if (isEditMode) {
//     payload.id = editRow.id || editRow.job_works_jobs_details_id;
//   }

//   // 🔹 DEBUG: print payload before API call
//   console.log("Submitting Receive Cutpiece Payload:", {
//     isEditMode,
//     editRow,
//     payload,
//     receiveQtyMap,
//     selectedRows,
//     formData,
//   });

//   try {
//     const token = localStorage.getItem("token");

//     const res = await axios.post(
//       `${BASE_URL}/receiveCutpieceAddEdit`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data?.status === true) {
//       Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: res.data.message || "Cut piece received successfully",
//         timer: 2000,
//         showConfirmButton: false,
//       });
//       await fetchReceiveCutpieceList();
//       // ✅ RESET STATE
//       setShowModal(false);
//       setSelectedRows([]);
//       setReceiveQtyMap({});
//       setModalTableData([]);
//       setIsEditMode(false);
//       setEditRow(null);

//       // Optional refresh
//       // fetchReceiveCutpieceList();
//     }
//   } catch (error) {
//     console.error("Receive cutpiece submit failed", error);
//     if (handle401(error)) return;

//     Swal.fire("Error", "Something went wrong", "error");
//   }
// };

const handleSubmitReceiveCutpiece = async () => {
  // =========================
  // ✅ ADD MODE VALIDATION
  // =========================
  if (!isEditMode && selectedRows.length === 0) {
    return Swal.fire("Warning", "Please select at least one row", "warning");
  }

  let jobIds = [];
  let receiveQtyArr = [];
  let pendingQtyArr = [];

  if (isEditMode) {
    // =========================
    // ✅ EDIT MODE
    // =========================
    if (!editRow) {
      Swal.fire("Error", "No row selected for edit", "error");
      console.error("editRow is null!");
      return;
    }

    const jobId = editRow.job_works_jobs_details_id || editRow.id;
    const receiveQty = receiveQtyMap[jobId] || 0;

    if (receiveQty <= 0) {
      return Swal.fire(
        "Warning",
        "Receive quantity must be greater than 0",
        "warning"
      );
    }

    jobIds = [jobId];
    receiveQtyArr = [receiveQty];
    pendingQtyArr = [(editRow.total_quantity || 0) - receiveQty];
  } else {
    // =========================
    // ✅ ADD MODE
    // =========================
    for (const row of selectedRows) {
      const receiveQty = receiveQtyMap[row.id] || 0;

      if (receiveQty <= 0) {
        return Swal.fire(
          "Warning",
          "Receive quantity must be greater than 0",
          "warning"
        );
      }

      jobIds.push(row.id);
      receiveQtyArr.push(receiveQty);
      pendingQtyArr.push(row.total_quantity - receiveQty);
    }
  }

  // =========================
  // ✅ CREATE PAYLOAD
  // =========================
  const payload = {
    receive_date: formData.issue_date,
    vendor_type_id: formData.issue_to,
    vendor_id: formData.vendor,
    job_works_jobs_details_id: jobIds,
    receive_quantity: receiveQtyArr,
    pending_quantity: pendingQtyArr,
    remarks: formData.remarks || "",
  };

  if (isEditMode) {
    payload.id = editRow.id || editRow.job_works_jobs_details_id;
  }

  console.log("Submitting Receive Cutpiece Payload:", {
    isEditMode,
    editRow,
    payload,
    receiveQtyMap,
    selectedRows,
    formData,
  });

  // =========================
  // ✅ API CALL
  // =========================
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/receiveCutpieceAddEdit`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // 🔴 HANDLE backend status:false even if HTTP 200
    if (res.data?.status === false) {
      return Swal.fire(
        "Failed",
        res.data.message || "Operation failed",
        "error"
      );
    }

    // ✅ SUCCESS
    Swal.fire({
      icon: "success",
      title: "Success",
      text: res.data.message || "Cut piece received successfully",
      timer: 2000,
      showConfirmButton: false,
    });

    // 🔹 WAIT for list refresh before resetting modal
    await fetchReceiveCutpieceList();

    // 🔹 RESET STATE
    setShowModal(false);
    setSelectedRows([]);
    setReceiveQtyMap({});
    setModalTableData([]);
    setIsEditMode(false);
    setEditRow(null);

  } catch (error) {
    console.error("Receive cutpiece submit failed", error);

    // ✅ Handle 401 Unauthorized
    if (handle401(error)) return;

    // 🔹 Show backend message if present
    const backendMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Something went wrong";

    Swal.fire("Error", backendMessage, "error");
  }
};




  const openAddModal = () => {
    setIsEditMode(false);
    setFormData({
      fabric_type: "",
      quantity: "",
      issue_date: today,
      issue_to: "",
      vendor: ""
    });
    setShowModal(true);
  };



  useEffect(() => {
    fetchVendorTypes()
  }, []);


  useEffect(() => {
  fetchReceiveCutpieceList(1, { vendor_type_id: "", vendor_id: "" }, perPage);
}, []);


  const theadStyle ={

                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",

  }

  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
      {/* HEADER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-scissors"></i> Receive Cut Piece
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Vendor Type</Form.Label>
    <Form.Select
      value={selectedVendorType}
      onChange={(e) => {
        const vendorTypeId = e.target.value;

        // Update selected vendor type
        setSelectedVendorType(vendorTypeId);

        // Reset vendor selection
        setFormData({ ...formData, vendor_id: "" });

        // Update filters for table/search
const newFilters = {
  vendor_type_id: vendorTypeId,
  vendor_id: "",
};

setFilters(newFilters);
// fetchReceiveCutpieceList(1, newFilters, perPage);

        // Fetch vendors for selected type
        if (vendorTypeId) {
          fetchVendorsByType(vendorTypeId);
        } else {
          setVendorList([]);
        }

      }}
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Select Vendor Type</option>
      {vendorTypeList.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendor_type_name} ({v.vendor_type_short_name})
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Vendor</Form.Label>
    <Form.Select
       value={filters.vendor_id || ""}
  onChange={(e) => {
    const vendorId = e.target.value;

    const newFilters = {
      ...filters,
      vendor_id: vendorId,
    };

    setFilters(newFilters);
    // fetchReceiveCutpieceList(1, newFilters, perPage);
  }}
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
      disabled={!selectedVendorType || vendorList.length === 0}
    >
      <option value="">Select Vendor</option>
      {vendorList.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

            <Col md={3}>
                                                  <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                            <Form.Select
                             style={{
                                            borderRadius: "10px",
                                            border: "2px solid #1565C1",
                                          }}
                              value={perPage}
  onChange={(e) => {
    const value = Number(e.target.value);
    setPerPage(value);
    setPage(1);

    // 🔥 reload list with current filters
    fetchReceiveCutpieceList(1, filters, value);
  }}

                            >
                              <option value={10}>10 Per Page</option>
                                          <option value={25}>25 Per Page</option>
                                          <option value={50}>50 Per Page</option>
                                          <option value={100}>100 Per Page</option>
                            </Form.Select>
                            </Form.Group>
                          </Col>
            <Col md={4} className="d-flex gap-3 mt-3">
                                                        {/* SEARCH */}
                                                        <Button
                                                          className="w-50 fw-semibold text-white"
                                                          style={{
                                                            background: "#1565C1",
                                                            border: "none",
                                                            borderRadius: "10px",
                                                            transition: "0.3s",
                                                          }}
                                                          onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                                                          onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
onClick={() => {
    // Trigger API call manually
fetchReceiveCutpieceList(1, getActiveFilters(), perPage);
  }}
                                                        >
                                                          <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                                                        </Button>

                                                        {/* RESET */}
                                                        <Button
                                                          className="w-50 fw-semibold text-white"
                                                          style={{
                                                            background: "#E53935",
                                                            border: "none",
                                                            borderRadius: "10px",
                                                            transition: "0.3s",
                                                          }}
                                                          onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                                                          onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                                                          onClick={() => {
  const clearedFilters = {
    vendor_type_id: "",
    vendor_id: "",
  };

  setFilters(clearedFilters);
  setSelectedVendorType("");
  setVendorList([]);
  setFormData({ ...formData, vendor_id: "", issue_to: "" });
  setPerPage(10);
  setPage(1);

  fetchReceiveCutpieceList(1, clearedFilters, 10);
}}



                                                        >
                                                          <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                                                        </Button>
                                                      </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ADD BUTTON */}
      <Button
        className="mb-3 text-white"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}

        onClick={openAddModal}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Receive Cut Piece
      </Button>

      {/* TABLE */}
      {!loading && (
        <Card className="border-0">
          <Table hover responsive striped>
            <thead>
              <tr className="text-center">
                <th style={theadStyle}>SL</th>
        <th style={theadStyle}>Receive Date</th>
        {/* <th style={theadStyle}>Vendor Type</th> */}
        <th style={theadStyle}>Vendor</th>
        <th style={theadStyle}>Item</th>
        <th style={theadStyle}>Size</th>
        <th style={theadStyle}>Total Qty</th>
        <th style={theadStyle}>Received Qty</th>
        <th style={theadStyle}>Pending Qty</th>
        <th style={theadStyle}>Fabric Req</th>
        <th style={theadStyle}>Return Date</th>
        <th style={theadStyle}>Action</th>


              </tr>
            </thead>
            <tbody>
               {receiveList.length > 0 ? (
        receiveList.map((row, index) => (
          <tr key={row.id} className="text-center">
            <td>{(page - 1) * perPage + index + 1}</td>
            <td>{formatDate(row.receive_date)}</td>
            {/* <td>{row.vendor_type_short_name}</td> */}
            <td>{row.vendors_master_name} ({row.vendor_type_short_name})</td>
            <td>{row.item_name}</td>
            <td>{row.size}</td>
            <td>{row.total_quantity}</td>
            <td className="text-success fw-bold">
              {row.receive_quantity}
            </td>
            <td className="text-danger fw-bold">
              {row.pending_quantity}
            </td>
            <td>{row.fabric_requirement}</td>
            <td>{formatDate(row.date_of_start_returning)}</td>
            <td className="text-center">
                                                                        <Button
                                                                          size="sm"
                                                                          className="me-2"
                                                                          style={{
                                                                            background: "#1565C1",
                                                                            border: "none",
                                                                            padding: "6px 10px",
                                                                            boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                                                                          }}
                                                                          onMouseEnter={(e) =>
                                                                            (e.currentTarget.style.background = "#0D47A1")
                                                                          }
                                                                          onMouseLeave={(e) =>
                                                                            (e.currentTarget.style.background = "#1565C1")
                                                                          }
                                                                          onClick={() => openEditModal(row)}
                                                                        >
                                                                          <i className="fa-solid fa-pen text-white"></i>
                                                                        </Button>

                                                                        {/* DELETE */}
                                                                        <Button
                                                                          size="sm"
                                                                          style={{
                                                                            background: "linear-gradient(90deg, #E53935, #D32F2F)",
                                                                            border: "none",
                                                                            padding: "6px 10px",
                                                                            boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                                                                          }}
                                                                          onMouseEnter={(e) =>
                                                                            (e.currentTarget.style.background =
                                                                              "linear-gradient(90deg, #D32F2F, #B71C1C)")
                                                                          }
                                                                          onMouseLeave={(e) =>
                                                                            (e.currentTarget.style.background =
                                                                              "linear-gradient(90deg, #E53935, #D32F2F)")
                                                                          }
                                                                                        onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                                                                       >
                                                                          <i className="fa-solid fa-trash-can text-white"></i>
                                                                        </Button>
                                                                      </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="11" className="text-center">
            No Data Found
          </td>
        </tr>
      )}
            </tbody>
          </Table>

          {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <nav>
                    <ul className="pagination shadow-sm">

                        {/* First */}
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => fetchReceiveCutpieceList(1)}>
                            «
                        </button>
                        </li>

                        {/* Prev */}
                        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => fetchReceiveCutpieceList(page - 1)}
                        >
                            ‹
                        </button>
                        </li>

                        {/* Page Numbers */}
                        {getPageNumbers().map((p) => (
                        <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                            <button
                            className="page-link"
                            onClick={() => fetchReceiveCutpieceList(p, getActiveFilters(), perPage)}
                            >
                            {p}
                            </button>
                        </li>
                        ))}

                        {/* Next */}
                        <li
                        className={`page-item ${
                            page === totalPages ? "disabled" : ""
                        }`}
                        >
                        <button
                            className="page-link"
                            onClick={() => fetchReceiveCutpieceList(page + 1)}
                        >
                            ›
                        </button>
                        </li>

                        {/* Last */}
                        <li
                        className={`page-item ${
                            page === totalPages ? "disabled" : ""
                        }`}
                        >
                        <button
                            className="page-link"
                            onClick={() => fetchReceiveCutpieceList(totalPages)}
                        >
                            »
                        </button>
                        </li>

                    </ul>
                    </nav>
                </div>
             )}
        </Card>
      )}

      {/* MODAL */}
      <Modal show={showModal} onHide={() => {
    setShowModal(false);
    resetModalState();
  }} centered size="lg">
        <Modal.Header closeButton style={{ background: "#3399ff", color: "#fff" }}>
          <Modal.Title>
            {isEditMode ? "Edit Receive Cutpiece" : "Receive Cutpiece"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Form.Group className="mb-2">
            <Form.Label>Receive Date <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="date"
              value={formData.issue_date}
              onChange={(e) =>
                setFormData({ ...formData, issue_date: e.target.value })
              }
            />
          </Form.Group>

          <Form.Group className="mb-2">
  <Form.Label>
    Select Vendor Type <span className="text-danger">*</span>
  </Form.Label>

<Form.Select
  value={formData.issue_to}
  onChange={(e) => {
    const vendorTypeId = e.target.value;

    setFormData({
      ...formData,
      issue_to: vendorTypeId,
      vendor: "",
    });

    setModalTableData([]); // clear old table
    fetchVendorsByType(vendorTypeId);
  }}
>
  <option value="">Select Vendor Type</option>
  {vendorTypeList.map((v) => (
    <option key={v.id} value={v.id}>
      {v.vendor_type_name} ({v.vendor_type_short_name})
    </option>
  ))}
</Form.Select>


</Form.Group>


          <Form.Group className="mb-2">
            <Form.Label>Select Vendor <span className="text-danger">*</span></Form.Label>
            {/* <Form.Select
              value={formData.vendor}
              onChange={(e) =>
                setFormData({ ...formData, vendor: e.target.value })
              }
            >
              <option value="">Select</option>
              {vendorList.map((i, idx) => (
<option key={i.id} value={i.id}>
  {i.vendors_master_name}
</option>
              ))}
            </Form.Select> */}

           <Form.Select
  value={formData.vendor}
  onChange={(e) => {
    const vendorId = e.target.value;

    setFormData({ ...formData, vendor: vendorId });

    fetchReceiveCutpieceForModal(formData.issue_to, vendorId);
  }}
>
  <option value="">Select Vendor</option>
  {vendorList.map((v) => (
    <option key={v.id} value={v.id}>
      {v.vendors_master_name}
    </option>
  ))}
</Form.Select>


          </Form.Group>


<hr />

<h6 className="fw-bold mb-2">Receive Cut Piece List</h6>

{modalLoading ? (
  <p className="text-center">Loading...</p>
) : (
  <Table bordered hover responsive size="sm">

    {/* SHOW HEADER ONLY WHEN DATA EXISTS */}
    {modalTableData.length > 0 && (
      <thead className="table-light text-center">
        <tr>
          <th>Select</th>
          <th>SL</th>
          <th>Issue Date</th>
          <th>Item</th>

          <th>Size</th>
          <th>Fabric</th>
          <th>Fabric Req</th>
          <th>Total Qty</th>
          <th>Receive Qty</th>
          <th>Pending Qty</th>
          <th>Return Date</th>
        </tr>
      </thead>
    )}

    <tbody>
      {modalTableData.length > 0 ? (
        modalTableData.map((row, index) => (
          <tr key={row.id} className="text-center">
            <td>
              <Form.Check
                type="checkbox"
                checked={isRowSelected(row.id)}
                onChange={() => toggleRowSelection(row)}
              />
            </td>

            <td>{index + 1}</td>
            <td>{formatDate(row.issue_date)}</td>
            <td>{row.item_name}</td>
            <td>{row.size}</td>
            <td>{row.fabric_master_name}</td>
            <td>{row.fabric_requirement}</td>
            <td>{row.total_quantity}</td>

             {/* RECEIVE QTY */}
<td>
  <Form.Control
  type="number"
  size="sm"
  min={0}
  max={row.total_quantity}
  disabled={!isRowSelected(row.id)}
  value={receiveQtyMap[row.id] ?? ""}
  onChange={(e) =>
    handleReceiveQtyChange(row, e.target.value)
  }
  style={{ width: "80px", textAlign: "center" }}
/>

</td>


          {/* PENDING QTY */}
          <td>
            <Form.Control
  type="number"
  size="sm"
  disabled
  value={
    isRowSelected(row.id)
      ? row.total_quantity - (receiveQtyMap[row.id] || 0)
      : row.total_quantity
  }
  style={{ width: "80px", textAlign: "center" }}
/>

          </td>
            <td>{formatDate(row.date_of_start_returning)}</td>
          </tr>
        ))
      ) : null}
    </tbody>
  </Table>
)}






          {/* Beneficiary ID - only for SHG */}
                    {formData.issue_to === "SHG" && (
                      <Form.Group className="mb-2">
                        <Form.Label>Beneficiary ID (Optional)</Form.Label>
                        <Form.Control
                          placeholder="Enter Beneficiary ID"
                          value={formData.beneficiary_id}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              beneficiary_id: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    )}



          <Form.Group className="mb-2">
            <Form.Label>Remarks(Optional)</Form.Label>
            <Form.Control
              type="text"
              value={formData.remarks}
              placeholder="remarks"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remarks: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)} variant="danger">Cancel</Button>
          <Button variant="success" onClick={handleSubmitReceiveCutpiece}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IssueFabric;
